import { Routes, Route, BrowserRouter } from "react-router-dom";
import Topbar from './components/Topbar/Topbar';
import Navbar from './components/Navbar/Navbar';

//Notifications
import 'react-notifications/lib/notifications.css'; 
import { NotificationContainer } from 'react-notifications';


import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './assets/css/Form.css'
import './assets/css/AdminPanel.css'

//Screens
import InitialScreen from './screens/InitialScreen/InitialScreen';

function App() {

  return (
    <div className="App">
      <Topbar />
      <main>
        <div >
          <BrowserRouter basename='/'>
            <Navbar />
            <Routes>
              <Route index path="/" element={<InitialScreen />} />
              <Route path="/string/"  >
                <Route path="create" element={<> </>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </main>
      <NotificationContainer />
    </div>
  );
}

export default App;
